import { useRef, useEffect, useState, useCallback, ChangeEvent } from 'react'
import { startSxpProxy } from '../../utils/api'
import '../membership/membership.scss'
import {
  AB_MEMBERHSIP_PROJECT_ID,
  ADMIN_PROJECT_ID,
  ODOO_COGNITIVECARE_INVOICE,
  pageSizeOptions,
} from '../../utils/constants'
import { useAppDispatch, useAppSelector } from '../../app/hooks'
import { selectSelectedLocationId } from '../location/locationSlice'
import { NavLink, useNavigate } from 'react-router-dom'
import { MEMBERSHIP_UPDATE } from '../../utils/roles'
import KeycloakService from '../../utils/keycloakService'
import MaskedNumber from '../../components/MaskedNumber'
import { odooPharmacyLink } from '../appointments/models'
import ProvenanceView from '../../components/ProvenanceView'
import { create } from '../lms/constants'
import MembershipSearch from '../membership/MembershipSearch'
import {
  selectQuery,
  selectParam,
  setQueryParam,
} from '../membership/membershipSlice'
import { PaginateModel, MembershipModel } from '../membership/models'
import {
  ABmembership,
  ABMembershipIntent,
  AyuvuBharosa,
  Expired,
  membershipCreate,
  MemeberStatus,
  noinvoice,
  resize,
  Status,
  unpaidString,
} from './constants'
import {
  ABMemberDashboard,
  editABMembership,
} from '../bedManagement/endpoints/EndPoints'
import { forms } from '../administration/constants'
import { openUrlFromApi } from '../patients/utils'
import { toast } from 'react-toastify'
import CustomHeader from '../Radiology/components/RadiologyModel/CustomHeader'
import { ColDef } from 'ag-grid-community'
import { Box, Button, IconButton, Tooltip, useTheme } from '@mui/material'
import MedAgDataGrid from '../../components/MedAgDataGrid'
import useCustomStyles from '../../utils/hooks/CustomStylesHook'
import { KeyboardArrowLeft, KeyboardArrowRight } from '@mui/icons-material'
import OpenInNewIcon from '@mui/icons-material/OpenInNew'
import EditNoteIcon from '@mui/icons-material/EditNote'
import PrintIcon from '@mui/icons-material/Print'
const styles = () => ({
  patientheading: {
    color: '#090968',
    fontSize: '16px',
    fontWeight: 600,
  },
  deviceText: {
    color: '#090968',
    fontSize: '16px',
    fontWeight: 600,
  },
  centerHeader: {
    color: '#ffffff',
    textAlign: 'center',
    '& .ag-header-cell-text': {
      flex: 1,
    },
  },
  abMembershipMainContainer: {
    width: '100%',
    height: '100%',
    padding: '0.5rem',
  },
  abMembershipSubContainer: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-between',
  },
  editIcon: {
    width: '18px',
  },
  calendarMonthIcon: {
    color: '#625e5e !important',
    width: '22px',
    height: '20px',
  },
  unpaidLink: {
    textTransform: 'initial',
    outline: 'border-box',
    background: '#E35335',
    color: 'white',
    padding: '0px 2px',
    fontSize: '10px',
    '&:hover': {
      background: '#E35335',
    },
  },
  paidLink: {
    textTransform: 'initial',
    outline: 'border-box',
    background: 'green',
    color: 'white',
    padding: '0px 2px',
    fontSize: '10px',
    '&:hover': {
      background: 'green',
    },
  },
  endIcon: {
    fontSize: '13px !important',
  },
  printIcon: {
    width: '20px',
    height: '20px',
  },
})
const ABMembershipDashboard = () => {
  const theme = useTheme()
  const classes = useCustomStyles(styles, theme)
  const query = useAppSelector(selectQuery)
  const param = useAppSelector(selectParam)
  const dispatch = useAppDispatch()
  const [loading, setLoading] = useState(true)
  const navigate = useNavigate()
  const [currentPage, setCurrentPage] = useState(1)
  const [limit, setLimit] = useState(100)
  const [paginate, setPaginate] = useState<PaginateModel>({
    totalCount: 0,
    totalPages: 0,
    data: [],
  })
  const [memberships, setMemberships] = useState<MembershipModel[]>([])
  const filteredMemberships = memberships?.filter(
    (e) => e?.partner?.ref !== false
  )
  const location = useAppSelector(selectSelectedLocationId)
  const handlePageChange = (newPage: any) => {
    setCurrentPage(newPage)
  }

  useEffect(() => {
    setCurrentPage(1)
  }, [limit, paginate.totalCount])
  const getMemberships = useCallback(
    (q: any, p: any) => {
      const state = {
        location,
        [q]: p,
        limit: limit,
        offset: (currentPage - 1) * limit,
        membershipType: AyuvuBharosa,
      }
      startSxpProxy(
        AB_MEMBERHSIP_PROJECT_ID,
        ABMembershipIntent?.abMembershipLines,
        state
      )
        ?.then((data) => {
          setPaginate({
            totalCount: data?.data?.total_count,
            totalPages: data?.data?.total_pages,
            data: data?.data?.data,
          })
          const members: MembershipModel[] = data?.data?.data ?? []
          setMemberships(members)
        })
        ?.catch((err) => {
          console?.log(err)
          setMemberships([])
          setPaginate({
            totalCount: 0,
            totalPages: 0,
            data: [],
          })
        })
        ?.finally(() => setLoading(false))
    },
    [location, currentPage, limit]
  )
  const index = (currentPage - 1) * limit
  const startIndex = index + 1
  const endIndex = Math?.min(index + limit, paginate?.totalCount)
  useEffect(() => {
    setLoading(true)
    getMemberships(query, param)
  }, [getMemberships, query, param])

  const membershipTableContainerRef = useRef<HTMLDivElement | null>(null)
  useEffect(() => {
    const resizeHandler = () => {
      const container = membershipTableContainerRef.current
      if (container) {
        const availableHeight: any =
          window.innerHeight - container?.getBoundingClientRect().top
        container.style.maxHeight = `${availableHeight - 60}px`
      }
    }
    window.addEventListener(`${resize}`, resizeHandler)
    resizeHandler()
    return () => {
      window.removeEventListener(`${resize}`, resizeHandler)
      dispatch(setQueryParam({ q: '', param: '' }))
    }
  }, [dispatch])

  const handleCreateMembership = () => {
    navigate(`${membershipCreate}`)
  }
  const openOdooInvoice = (id: any) => {
    openUrlFromApi(ADMIN_PROJECT_ID, odooPharmacyLink, {
      invoiceId: id,
      location: location,
    })
  }
  const onEdit = (id: any) => {
    navigate(`${editABMembership}/${id}`)
  }
  const statusFunction = (id: string) => {
    switch (id) {
      case `${Status?.paid}`:
        return `${MemeberStatus?.paid}`
      case `${Status?.none}`:
        return `${MemeberStatus?.none}`
      case `${Status?.waiting}`:
        return `${MemeberStatus?.waiting}`
      case `${Status?.invoiced}`:
        return `${MemeberStatus?.invoiced}`
      case `${Status?.canceled}`:
        return `${MemeberStatus?.canceled}`
      case `${Status?.old}`:
        return `${MemeberStatus?.old}`
      default:
        return `${MemeberStatus?.Others}`
    }
  }
  const dateCheck = (date: string) => {
    const d1 = new Date(date)
    const d2 = new Date()
    if (d1 >= d2) {
      return `${forms?.active}`
    } else {
      return `${Expired}`
    }
  }
  const handleSizeChange = (e: ChangeEvent<HTMLSelectElement>) => {
    setLimit(Number(e?.target?.value))
  }
  const handleInvoiceClick = (id: any) => {
    if (id) {
      window.open(`${ODOO_COGNITIVECARE_INVOICE}/${id}`, '_blank')
    } else {
      toast.error(noinvoice, {
        position: toast.POSITION.TOP_CENTER,
        autoClose: 3000,
      })
    }
  }
  const handleStatusLink = (params: any) => {
    const d = params?.data
    return d?.state === `${Status?.invoiced}` ||
      d?.state === `${Status?.waiting}` ? (
      <>
        <div>
          {d?.cognitivecare_invoice_id === 0 ? (
            <Button
              onClick={() =>
                d?.cognitivecare_invoice_id === 0 &&
                openOdooInvoice(d?.account_invoice_id?.id)
              }
              endIcon={<OpenInNewIcon className={classes?.endIcon} />}
              className={classes?.unpaidLink}
            >
              {unpaidString}
            </Button>
          ) : (
            <span>{unpaidString}</span>
          )}
        </div>
      </>
    ) : (
      '-'
    )
  }
  const invoicePrint = (params: any) => {
    const d = params?.data
    return (
      <div
        onClick={() => handleInvoiceClick(d?.cognitivecare_invoice_id)}
        className='text-center'
      >
        <PrintIcon titleAccess='Print Report' className={classes?.printIcon} />
      </div>
    )
  }
  const editAction = (params: any) => {
    const d = params?.data
    return (
      <Tooltip title='Edit Ab Membership'>
        <IconButton
          size='small'
          onClick={
            KeycloakService.hasRole([MEMBERSHIP_UPDATE])
              ? () => onEdit(d?.id)
              : undefined
          }
          disabled={!KeycloakService.hasRole([MEMBERSHIP_UPDATE])}
          className={`custom-btn custom-btn-primary ml10 ${
            KeycloakService.hasRole([MEMBERSHIP_UPDATE])
              ? 'cursor-pointer'
              : 'auth-disabled cursor-default'
          }`}
        >
          <EditNoteIcon
            fontSize='small'
            className={classes?.calendarMonthIcon}
          />
        </IconButton>
      </Tooltip>
    )
  }
  const columnDefs: ColDef[] = [
    {
      headerName: 'SL No',
      field: 'slNo',
      width: 80,
      sortable: false,
      filter: false,
      cellRenderer: (params: any) =>
        (currentPage - 1) * limit + (params?.node?.rowIndex + 1),
      headerClass: 'custom-header-cell',
      cellClass: 'custom-header-cell',
      cellStyle: { fontSize: '12px', textAlign: 'center' },
    },
    {
      headerName: 'Membership ID',
      field: 'membershipId',
      width: 140,
      sortable: false,
      filter: false,
      cellRenderer: (params: any) => (
        <NavLink to={`${ABMemberDashboard}${params?.data?.id}`}>
          {params?.data?.name}
        </NavLink>
      ),
      headerClass: 'custom-header-cell',
      cellClass: 'custom-header-cell',
      cellStyle: { fontSize: '12px', textAlign: 'center' },
    },
    {
      headerName: 'UHID',
      field: 'name',
      flex: 1,
      minWidth: 140,
      sortable: false,
      filter: false,
      headerComponent: CustomHeader,
      cellRenderer: (params: any) => params?.data?.partner?.ref ?? '-',
      cellClass: 'custom-header-cell',
      headerClass: 'custom-header-cell',
      cellStyle: { fontSize: '12px', textAlign: 'center' },
    },
    {
      headerName: 'Primary',
      field: 'primary',
      minWidth: 250,
      sortable: true,
      filter: true,
      cellRenderer: (params: any) => params?.data?.partner?.name ?? '-',
      headerComponent: CustomHeader,
      headerClass: classes?.centerHeader,
      cellClass: 'custom-header-cell',
      cellStyle: {
        fontSize: '12px',
        textAlign: 'left',
        wordBreak: 'break-word',
        overflowWrap: 'break-word',
        lineHeight: 1,
        display: 'flex',
        alignItems: 'center',
      },
      wrapText: true,
    },
    {
      headerName: 'Mobile',
      field: 'mobile',
      flex: 1,
      minWidth: 130,
      sortable: false,
      filter: true,
      headerComponent: CustomHeader,
      cellRenderer: (params: any) =>
        params?.data?.partner?.phone ? (
          <MaskedNumber mobile={params?.data?.partner?.phone} />
        ) : (
          '-'
        ),
      cellClass: 'custom-header-cell',
      headerClass: 'custom-header-cell',
      cellStyle: { fontSize: '12px', textAlign: 'center' },
    },
    {
      headerName: 'Operating Unit',
      field: 'operatingUnit',
      flex: 1,
      minWidth: 140,
      sortable: false,
      filter: false,
      cellRenderer: (params: any) => {
        return (
          <>
            {params?.data?.account_invoice_id?.operating_unit_id?.[1]?.split(
              ' '
            )?.[1] ?? '-'}
          </>
        )
      },
      cellClass: 'custom-header-cell',
      headerClass: 'custom-header-cell',
      cellStyle: { fontSize: '12px', textAlign: 'center' },
    },
    {
      headerName: 'Membership',
      field: 'membership',
      minWidth: 225,
      sortable: true,
      filter: true,
      cellRenderer: (params: any) => params?.data?.membership_id?.[1] ?? '-',
      headerComponent: CustomHeader,
      cellClass: 'custom-header-cell',
      headerClass: 'custom-header-cell',
      cellStyle: { fontSize: '12px', textAlign: 'center' },
    },
    {
      headerName: 'Validity',
      field: 'validity',
      minWidth: 150,
      sortable: true,
      filter: true,
      cellRenderer: (params: any) => statusFunction(params?.data?.state),
      headerComponent: CustomHeader,
      cellClass: 'custom-header-cell',
      headerClass: 'custom-header-cell',
      cellStyle: {
        fontSize: '12px',
        textAlign: 'left',
      },
      wrapText: true,
    },
    {
      headerName: 'Mem Status',
      field: 'status',
      minWidth: 135,
      sortable: false,
      filter: false,
      cellRenderer: (params: any) => {
        const d = params?.data
        return d?.date_to ? dateCheck(d?.date_to) : '-'
      },
      cellClass: 'custom-header-cell',
      headerClass: 'custom-header-cell',
      cellStyle: {
        fontSize: '12px',
        textAlign: 'center',
      },
      wrapText: true,
    },
    {
      headerName: 'Pay.Status',
      field: 'validity',
      flex: 1,
      minWidth: 130,
      sortable: true,
      filter: true,
      cellRenderer: handleStatusLink,
      headerComponent: CustomHeader,
      cellClass: 'custom-header-cell',
      headerClass: 'custom-header-cell',
      cellStyle: {
        fontSize: '12px',
        textAlign: 'center',
        wordBreak: 'break-word',
        overflowWrap: 'break-word',
        display: 'flex',
        justifyContent: 'center',
        lineHeight: 1.5,
      },
      wrapText: true,
    },
    {
      headerName: 'CC Invoice',
      field: 'ccInvoice',
      flex: 1,
      minWidth: 120,
      sortable: true,
      filter: true,
      cellRenderer: invoicePrint,
      headerComponent: CustomHeader,
      cellClass: 'custom-header-cell',
      headerClass: 'custom-header-cell',
      cellStyle: {
        fontSize: '12px',
        textAlign: 'center',
        wordBreak: 'break-word',
        overflowWrap: 'break-word',
        display: 'flex',
        justifyContent: 'center',
        lineHeight: 1.5,
      },
      wrapText: true,
    },
    {
      headerName: 'Action',
      field: 'edit',
      flex: 1,
      minWidth: 80,
      sortable: true,
      filter: false,
      cellRenderer: editAction,
      cellClass: 'custom-header-cell',
      headerClass: 'custom-header-cell',
      cellStyle: {
        fontSize: '12px',
        textAlign: 'center',
        wordBreak: 'break-word',
        overflowWrap: 'break-word',
        display: 'flex',
        justifyContent: 'center',
        lineHeight: 1.5,
      },
      wrapText: true,
    },
    {
      headerName: 'Created By',
      field: 'CreatedBy',
      minWidth: 200,
      sortable: true,
      filter: true,
      cellRenderer: (params: any) => (
        <ProvenanceView
          mode={create}
          date={params?.data?.account_invoice_id?.invoice_date_time ?? ''}
          name={params?.data?.account_invoice_id?.thop_user_name ?? ''}
        />
      ),
      headerComponent: CustomHeader,
      cellClass: 'custom-header-cell',
      headerClass: 'custom-header-cell',
      cellStyle: {
        fontSize: '12px',
        textAlign: 'left',
        wordBreak: 'break-word',
        overflowWrap: 'break-word',
        display: 'flex',
        alignItems: 'center',
        lineHeight: 1,
      },
      wrapText: true,
    },
  ]
  return (
    <div className={classes?.abMembershipMainContainer}>
      <div className={classes?.abMembershipSubContainer}>
        <div className='membership-dashboard-text'>{ABmembership}</div>
      </div>
      <Box height={'96%'} width={'100%'} marginTop={'-27px'}>
        <MedAgDataGrid
          tableHeight={'100%'}
          rowData={filteredMemberships}
          columnDefs={columnDefs}
          pagination={false}
          searchField={false}
          headerHeight={30}
          rowHeight={40}
          exportIcon={false}
          globalSearch={
            <MembershipSearch
              onCreate={handleCreateMembership}
              memberships={filteredMemberships}
            />
          }
          localSearch={false}
          enableCellTextSelection={true}
          loading={loading ? true : false}
        />
      </Box>
      <div className='text-right pagination-main-content'>
        <div className='inline-block membership-pagination text-right'>
          <select
            className='rowsperpage pagination-container'
            defaultValue={limit}
            onChange={handleSizeChange}
          >
            {pageSizeOptions?.map((size: number) => (
              <option key={size}>{size}</option>
            ))}
          </select>
          <span>
            <span className='mr10 pagination-container'>
              {startIndex}-{endIndex}/{paginate?.totalCount}{' '}
            </span>
          </span>
        </div>

        <div className='pagination-count-content'>
          <button
            onClick={() => handlePageChange(currentPage - 1)}
            className={`icon-disable-btn ${
              currentPage !== 1 ? '' : 'disableBtn'
            }`}
            disabled={currentPage === 1}
          >
            <KeyboardArrowLeft />
          </button>
          <button
            onClick={() => handlePageChange(currentPage + 1)}
            className={`icon-disable-btn ${
              currentPage !== paginate?.totalPages ? '' : 'disableBtn'
            }`}
            disabled={currentPage === paginate?.totalPages}
          >
            <KeyboardArrowRight />
          </button>
        </div>
      </div>
    </div>
  )
}

export default ABMembershipDashboard
